import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';
import MediaQuery from 'react-responsive';
import { browserHistory } from 'react-router';
import ReactGA from 'react-ga';

import Reps from './Reps.js';
import ErrorMsg from './Error.js';
import reload from './reload.svg';

class Results extends Component {
  constructor(props) {
    super(props);

    this.state = {
      zip: null,
      validZip: false,
    };
  }

  componentWillMount() {
    if (this.props.params.zipCode) {
      this.props.fetchWithZip(this.props.params.zipCode);
      this.setState({zip: this.props.params.zipCode});
    } else if (!this.props.zip) {
      browserHistory.replace('/')
    }
  }

  componentDidMount() {
    this.setState({zip: this.props.zip});
  }

  handleChange = (event) => {
    const validZip = !isNaN(event.target.value);
    this.setState({
      [event.target.name]: event.target.value,
      validZip
    });
  }

  handleClick = () => {
    ReactGA.event({
      category: 'Bespoke Contact Congress',
      action: 'click',
      label: 'zip changed',
      value: parseInt(this.state.zip, 10)
    });
    this.props.fetchWithZip(this.state.zip);
  }

  render() {
    const results = (this.props.fetching) ? (
      <div className="loader-wrapper">
        <div className="r29-loader-subtle"> </div>
      </div>
    ) :(this.props.reps.length) ? (
      <div>
        <MediaQuery query='(max-width: 639px)'>
          <Reps {...this.props} slidesClip={1} />
        </MediaQuery>
        <MediaQuery query='(min-width: 640px)'>
          <Reps {...this.props} slidesClip={2} />
        </MediaQuery>
      </div>
    ) : (
      <ErrorMsg />
    );
    return (
      <div className="Results">
        <h2>Your Representatives</h2>
        <form className="zipForm" onSubmit={(event) => {
            event.preventDefault();
            event.stopPropagation();
            this.props.fetchWithZip(this.state.zip);
          }}>
          <label className="zipLabel" htmlFor="zip">Zip Code:</label>
          <MaskedInput
            type="tel"
            id="zip"
            name="zip"
            placeholder="12345"
            onChange={this.handleChange}
            value={this.state.zip}
            mask={[/\d/, /\d/, /\d/, /\d/, /\d/]} />
          <button
            disabled={!this.state.validZip}
            onClick={this.handleClick}
            className="button reload"
            type="submit"><img src={reload} /></button>
        </form>
        {results}
      </div>
    );
  }
};

export default Results;




// WEBPACK FOOTER //
// ./src/Results.js